// Imports

const { id, log, keyMatch } = require("../std/index")
const { findWidgetInstances } = require("../widgets/index")



//
// Lightbox Controller
//
// Is special because it needs to run on the whole page, linking and lightbox
// trigger widgets to their counterparts
//



//
// Lightbox Controller
//
// Is special because it needs to run on the whole page, linking and lightbox
// trigger widgets to their counterparts
//

module.exports = class LightboxController {
  constructor($page, $$) {
    const fadeTime = 200;

    // Find relevant widgets
    const lightboxTriggers = findWidgetInstances($page, 'lightbox');

    // State
    this.state = {
      lightboxShowing: false
    };

    // Dom
    this.dom = {
      close: $$('[data-lightbox-close]'),
      overlay: $$('[data-lightbox-overlay]'),
      lightboxes: $$('[data-lightbox-id]')
    };

    // Listeners
    lightboxTriggers.map(trigger => trigger.onClick(this.showLightbox.bind(this)));
    this.dom.close.on('click', this.handleCloseClick.bind(this));
    this.dom.overlay.on('click', this.hideOverlayIfTrueTarget.bind(this));
    $(document).on('keydown', keyMatch(27, this.hideOverlayIfShowing.bind(this)));

    // Init
    this.dom.overlay.hide();
    this.dom.lightboxes.hide();

    // Handle cookie-based popups
    this.initCookiePopups();
  }

  /**
   * Generate a simple hash from lightbox content for change detection
   * @param {jQuery} lightboxElement - The lightbox DOM element
   * @returns {string} - Hash of the content
   */
  generateContentHash(lightboxElement) {
    const $lightbox = $(lightboxElement);
    const content = {
      title: $lightbox.find('[data-lightbox-title]').text().trim(),
      text: $lightbox.find('[data-lightbox-text]').text().trim(),
      image: $lightbox.find('[data-lightbox-image]').attr('src') || $lightbox.find('[data-lightbox-image]').attr('data-src') || '',
      buttonText: $lightbox.find('[data-lightbox-button]').text().trim()
    };

    // Create a simple hash from the content
    const contentString = JSON.stringify(content);
    let hash = 0;
    for (let i = 0; i < contentString.length; i++) {
      const char = contentString.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash).toString(36);
  }

  /**
   * Set a cookie with 30-day expiry
   * @param {string} name - Cookie name
   * @param {string} value - Cookie value
   */
  setCookie(name, value) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 days
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
  }

  /**
   * Get a cookie value
   * @param {string} name - Cookie name
   * @returns {string|null} - Cookie value or null if not found
   */
  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * Delete a cookie
   * @param {string} name - Cookie name
   */
  deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }

  initCookiePopups() {
    const cookieLightboxes = this.dom.lightboxes.filter('[data-cookie-managed]');
    cookieLightboxes.each((index, element) => this.checkAndShowCookiePopup(element));
  }

  checkAndShowCookiePopup(lightbox) {
    const lightboxId = $(lightbox).data('lightbox-id');

    // Generate content hash for change detection
    const currentContentHash = this.generateContentHash(lightbox);

    // Check if popup was dismissed and if content has changed
    const dismissedData = this.getPopupDismissedData(lightboxId);

    if (!dismissedData || dismissedData.contentHash !== currentContentHash) {
      const self = this;
      setTimeout(() => self.showLightbox(lightboxId), 1000);
    }
  }

  getPopupDismissedData(popupId) {
    try {
      const cookieValue = this.getCookie(`popup_dismissed_${popupId}`);

      if (!cookieValue) {
        return null;
      }

      // Parse the stored data (should contain contentHash and timestamp)
      return JSON.parse(cookieValue);
    } catch (error) {
      return null;
    }
  }

  isPopupDismissed(popupId) {
    // This method is kept for backward compatibility but now uses cookies
    const dismissedData = this.getPopupDismissedData(popupId);
    return dismissedData !== null;
  }

  dismissPopup(lightboxId) {
    const $lightbox = this.selectLightboxByName(lightboxId);
    const contentHash = this.generateContentHash($lightbox[0]);

    const dismissedData = {
      contentHash: contentHash,
      dismissedAt: new Date().toISOString()
    };

    const cookieKey = `popup_dismissed_${lightboxId}`;
    this.setCookie(cookieKey, JSON.stringify(dismissedData));
  }

  handleCloseClick(event) {
    let lightboxId = $(event.target).closest('[data-lightbox-id]').data('lightbox-id');
    let isCookieManaged = false;

    // If close button is outside lightbox containers, find the currently visible lightbox
    if (!lightboxId) {
      const visibleLightbox = this.dom.lightboxes.filter(':visible');
      if (visibleLightbox.length) {
        lightboxId = visibleLightbox.data('lightbox-id');
        isCookieManaged = visibleLightbox.is('[data-cookie-managed]');
      }
    } else {
      isCookieManaged = $(event.target).closest('[data-lightbox-id]').is('[data-cookie-managed]');
    }

    if (lightboxId && isCookieManaged) {
      this.dismissPopup(lightboxId);
    }
    this.hideOverlay();
  }

  selectLightboxByName(name) {
    return this.dom.lightboxes.filter(`[data-lightbox-id="${name}"]`).eq(0);
  }

  showOverlay() {
    this.dom.overlay.fadeIn(200);
    this.state.lightboxShowing = true;
  }

  hideOverlay() {
    this.dom.overlay.fadeOut(200);
    this.state.lightboxShowing = false;
  }

  hideOverlayIfTrueTarget(event) {
    if (event.target === this.dom.overlay[0]) {
      const visibleLightbox = this.dom.lightboxes.filter(':visible');
      if (visibleLightbox.length && visibleLightbox.is('[data-cookie-managed]')) {
        this.dismissPopup(visibleLightbox.data('lightbox-id'));
      }
      this.hideOverlay();
    }
  }

  hideOverlayIfShowing() {
    if (this.state.lightboxShowing) {
      this.hideOverlay();
    }
  }

  showLightbox(name) {
    this.dom.lightboxes.hide();
    const target = this.selectLightboxByName(name).show();
    this.showOverlay();
  }
};
